// extracted by mini-css-extract-plugin
module.exports = {"offersButton":"OffersButton_offersButton__M9PqB","hidden":"OffersButton_hidden__EaqLZ"};